<template lang="pug">
</template>

<script>
import { mapState, mapActions } from 'vuex'

export default {
  name: 'AppUpdateWarning',

  computed: {
    ...mapState({
      appUpdateWarningShown: state => state.tools.appUpdateWarningShown,
    }),
  },

  created() {
    if (this.$isCordova() && !this.appUpdateWarningShown) {
      this.checkAppVersion()
    }
  },

  methods: {
    ...mapActions({
      showConfirm: 'confirm/showConfirm',
      firebaseRemoteConfigGetString: 'tools/firebaseRemoteConfigGetString',
      setAppUpdateWarningShown: 'tools/setAppUpdateWarningShown',
      analyticsLogEvent: 'analytics/logEvent',
    }),

    checkAppVersion() {
      this.firebaseRemoteConfigGetString('APP_MINIMAL_VERSION').then((result) => {
        console.log('Minimal version from Firebase:', result)

        // Проверяем, что result имеет правильный формат версии X.X.X
        if (!this.isValidVersionFormat(result)) {
          console.warn('Invalid version format received from Firebase:', result)
          return
        }

        // Получаем текущую версию приложения
        if (window.cordova && window.cordova.getAppVersion) {
          window.cordova.getAppVersion.getVersionNumber().then((currentVersion) => {
            console.log('Current app version:', currentVersion)

            // Сравниваем версии
            if (this.compareVersions(currentVersion, result) < 0) {
              console.log('App needs update')
              this.showUpdateDialog()
            } else {
              console.log('App is up to date')
            }
          }).catch((error) => {
            console.error('Error getting app version:', error)
          })
        } else {
          console.warn('Cordova getAppVersion plugin not available')
        }
      }).catch((error) => {
        console.error('Error getting minimal version from Firebase:', error)
      })
    },

    // Проверяет, что строка имеет формат X.X.X
    isValidVersionFormat(version) {
      if (!version || typeof version !== 'string') {
        return false
      }

      const versionRegex = /^\d+\.\d+\.\d+$/
      return versionRegex.test(version.trim())
    },

    // Сравнивает две версии в формате X.X.X
    // Возвращает: -1 если version1 < version2, 0 если равны, 1 если version1 > version2
    compareVersions(version1, version2) {
      const v1Parts = version1.split('.').map(Number)
      const v2Parts = version2.split('.').map(Number)

      for (let i = 0; i < Math.max(v1Parts.length, v2Parts.length); i += 1) {
        const v1Part = v1Parts[i] || 0
        const v2Part = v2Parts[i] || 0

        if (v1Part < v2Part) return -1
        if (v1Part > v2Part) return 1
      }

      return 0
    },

    // Показывает диалог обновления приложения
    showUpdateDialog() {
      const updateUrl = this.$isAndroid()
        ? 'https://play.google.com/store/apps/details?id=kz.rekassa.cloud'
        : 'https://apps.apple.com/kz/app/rekassa-%D0%BA%D0%B0%D1%81%D1%81%D0%BE%D0%B2%D1%8B%D0%B9-%D0%B0%D0%BF%D0%BF%D0%B0%D1%80%D0%B0%D1%82/id1535504268'
      const platform = this.$isAndroid() ? 'android' : 'ios'

      this.setAppUpdateWarningShown(true)
      this.analyticsLogEvent({ eventName: 're_app_update_warning_shown', platform })

      this.showConfirm({
        title: this.$t('обновите_приложение'),
        icon: 'mdi-alert-circle-outline',
        text: this.$t('для_продолжения_работы_необходимо_обновить_приложение_до_последней_версии'),
        resolveText: this.$t('обновить'),
        rejectText: this.$t('позже'),
        persistent: true,
      }).then(() => {
        this.$openLink(updateUrl, '_system')
        this.analyticsLogEvent({ eventName: 're_app_update_warning_shown_update_clicked', platform })
      }).catch(() => {
        this.analyticsLogEvent({ eventName: 're_app_update_warning_shown_dismissed', platform })
      })
    },
  },
}
</script>

<style lang="stylus">
</style>
